import { useContext, useEffect, useState } from "react";
import CalendarIcon from "../../Assets/Icons/outline/calendar.svg";
import ColorPickerIcon from "../../Assets/Icons/outline/bucket.svg";
import CalendarPicker from "../../Components/CalendarPicker/CalendarPicker";
import Input from "../../Components/Input";
import moment from "moment";
import Select from "../../Components/Select";
import AdminContext from "../../Services/Admin";

const ProjectModal = ({ register, errors, control, setValue, data, reset, watch }) => {
	const { loading, getAllMaster } = useContext(AdminContext);
	const [datePicker, setDatePicker] = useState({ start: null, end: null });
	const [showCalendar, setShowCalendar] = useState(false);
	const [dataProject, setDataProject] = useState([]);
	const [dataIncentive, setDataIncentive] = useState([]);
	const dataLavel = [
		{ label: "Basic Project", value: "Basic Project" },
		{ label: "Simple Project", value: "Simple Project" },
		{ label: "Intermediate Project", value: "Intermediate Project" },
		{ label: "Advanced Project", value: "Advanced Project" },
		{ label: "Grand Project", value: "Grand Project" },
		{ label: "Master Project", value: "Master Project" },
	];

	useEffect(() => {
		let date = "";
		if (!showCalendar && datePicker?.start) {
			if (datePicker?.end) {
				date = moment(datePicker?.start)?.format("DD/MM/YYYY") + " - " + moment(datePicker?.end)?.format("DD/MM/YYYY");
			} else {
				date =
					moment(datePicker?.start)?.format("DD/MM/YYYY") + " - " + moment(datePicker?.start)?.format("DD/MM/YYYY");
			}
		}

		setValue("deadline", date);
	}, [showCalendar]);

	useEffect(() => {
		setValue(
			"deadline",
			datePicker?.start
				? datePicker?.end
					? moment(datePicker?.start)?.format("DD/MM/YYYY") + " - " + moment(datePicker?.end)?.format("DD/MM/YYYY")
					: moment(datePicker?.start)?.format("DD/MM/YYYY") + " - " + moment(datePicker?.start)?.format("DD/MM/YYYY")
				: ""
		);
	}, [datePicker]);

	const getDataProject = async () => {
		const newData = await getAllMaster(`project/detail`);
		if (newData) {
			setDataProject(
				newData?.map((item) => ({
					value: item?.id,
					label:
						item?.name +
						" (" +
						moment(item?.start).format("DD/MM/YYYY") +
						"-" +
						moment(item?.end).format("DD/MM/YYYY") +
						")",
				}))
			);
		}
	};

	const getDataIncentive = async () => {
		const newData = await getAllMaster(`master/incentive`);
		if (newData) {
			setDataIncentive(newData.data);
		}
	};

	const selectIncentiveList = (dataIncentive || []).map((item) => ({
		value: item?.id,
		label: item?.name,
	}));

	useEffect(() => {
		getDataProject();
		getDataIncentive();
	}, []);

	useEffect(() => {
		if (data) {
			const oldData = data;
			let bodyRequest = {};
			bodyRequest = {
				name: oldData?.name,
				description: oldData?.description,
				hex_code: oldData?.hex_code,
				level: oldData?.level,
				client_name: oldData?.client_name,
				t_projects_id: oldData?.t_projects_id,
				m_project_incentive_type_id: oldData?.m_project_incentive_type_id,
			};
			reset(bodyRequest);
			setDatePicker({ start: oldData?.start, end: oldData?.end });
		}
	}, [data]);

	console.log(errors);

	return (
		<>
			<div className="mb-5">
				<label htmlFor="name" className="block mb-3">
					Project Name <span className="text-red-500">*</span>
				</label>

				<div className="flex items-center">
					<div className="w-full">
						<Input
							id="name"
							placeholder="Input Project Name"
							required
							type="text"
							{...register("name")}
							errors={errors?.name?.message}
						/>
					</div>
					<div className="w-[60px] ms-3 mb-3 flex flex-col items-center" role="button">
						<label htmlFor="hex_code">
							<img src={ColorPickerIcon} className="w-[40px] h-[40px]" alt="" />
						</label>
						<input id="hex_code" required type="color" {...register("hex_code")} />
					</div>
				</div>
			</div>

			<div className="mb-5">
				<label htmlFor="client_name" className="block mb-3">
					Client Name <span className="text-red-500">*</span>
				</label>
				<div className="w-full">
					<Input
						id="client_name"
						placeholder="Input Client Name"
						required
						type="text"
						{...register("client_name")}
						errors={errors?.client_name?.message}
					/>
				</div>
			</div>

			<div className="mb-5">
				<label htmlFor="description" className="block mb-3">
					Project Description
				</label>
				<textarea
					id="description"
					className={`border border-black text-gray-900 rounded-xl focus:ring-black focus:border-black block w-full p-3`}
					placeholder="Input Project Description"
					required
					{...register("description")}
				/>
				{errors?.description?.message && <small className={`text-[red]`}>{errors?.description?.message}</small>}
			</div>

			{/* <div className="mb-5">
				<label htmlFor="level" className="block mb-3">
					Project Level <span className="text-red-500">*</span>
				</label>
				<Select control={control} id="level" data={dataLavel} />
				{errors?.level?.message && <small className={`text-[red]`}>{errors?.level?.message}</small>}
			</div> */}

			<div className="mb-5">
				<label htmlFor="level" className="block mb-3">
					Project Type <span className="text-red-500">*</span>
				</label>
				<Select control={control} id="m_project_incentive_type_id" data={selectIncentiveList} />
				{errors?.m_project_incentive_type_id?.message && (
					<small className={`text-[red]`}>{errors?.m_project_incentive_type_id?.message}</small>
				)}
			</div>

			<div className="mb-5">
				<label htmlFor="level" className="block mb-3">
					Project Relation
				</label>
				<Select control={control} id="t_projects_id" data={dataProject} />
			</div>

			<div className="mb-5 relative">
				<label htmlFor="deadline" className="block mb-3">
					Deadline <span className="text-red-500">*</span>
				</label>
				<div className="flex items-center">
					<div className="w-full">
						<Input id="deadline" placeholder="Input Deadline" required readOnly type="text" {...register("deadline")} />
					</div>
					<div className="w-[60px] ms-3 mb-3" role="button" onClick={() => setShowCalendar(true)}>
						<img src={CalendarIcon} className="w-[40px] h-[40px]" alt="" />
					</div>
				</div>
				{showCalendar && (
					<CalendarPicker datePicker={datePicker} setDatePicker={setDatePicker} setShowCalendar={setShowCalendar} />
				)}
			</div>
		</>
	);
};

export default ProjectModal;
